
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/customer-care/complaints",
      function () {
        return require("private-next-pages/help/customer-care/complaints/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/customer-care/complaints"])
      });
    }
  